import React, { useEffect, useState } from "react";
import { Box, Modal } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import Grid from '@material-ui/core/Grid';
import Skeleton from '@mui/material/Skeleton';
import { useDispatch } from "react-redux";
import * as Actions from "../../store/action/claimManagement";
import getDateFromString from "../../utils/getDateFromString";
import {getLabelClass, renderInputOrSpan , renderInputOrSpanForButton} from "../../utils/formUtils";
import {toggleExpansion} from "../../utils/toggleExpansion";
import {translateClientDecision} from "../../utils/translateClientDecision";
import { translateRepairDecision } from "../../utils/translateR";
import { Button, TextField, Typography } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

const useStyles = makeStyles((theme) => ({
  labelInput: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    textAlign: "left",
    color: "rgba(70, 78, 95, 1)",
    marginBottom: '10px'
  },
  styleInput: {
    borderRadius: "4px",
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    height: "36px",
    width: "250px",
    padding: "10px",
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    textAlign: "left",
    color: "rgba(70, 78, 95, 1)",
  },
  customAccordionItem : {
    width: "100%",
    marginBottom: "20px",
    borderRadius: "11px",
    border:`1px solid rgba(187, 200, 8, 1)`,

  },
  expanded: {
    border: "none",
  },
  styleSpan:{
    color: 'rgba(70, 78, 95, 1)',
    fontSize: '12px',
    fontWeight: 400,
    fontFamily: 'Poppins'
  },
  styleSpanLabel:{
    color: 'rgba(70, 78, 95, 1)',
    fontSize: '12px',
    fontWeight: 600,
    fontFamily: 'Poppins'
  },
  card: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginLeft: 0,
    },
    minHeight: '200px',
},
cardItem: {
    display: 'flex',
    justifyContent: 'space-between',
    color: 'rgba(128, 128, 143, 1)',
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: '13px',
    paddingBottom: '3px',
    paddingTop: '3px',
    alignItems: 'center',
    marginBottom: '10px',
},

}));

function PriseEnChargeSection(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [serviceProposals, setServiceProposals] = useState([]);
  const [reparationMissions, setReparationMissions] = useState([]);
  const [financialDocuments, setFinancialDocuments] = useState([]);
  const [error, setError] = useState(null);
  const claimNumber = props.claimNumber
  const renderAsSpans = props.renderAsSpans
  const [expandedItems, setExpandedItems] = useState(new Set([0]));
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const handlePaymentClick = () => {
    setShowPaymentModal(true);
  };

  const handleClosePaymentModal = () => {
    setShowPaymentModal(false);
  };  


  const fetchClaimAssociatedData = async () => {
    setLoading(true);
    setError(null);
    try {
      const claimServiceProposals = await dispatch(Actions.getClaimServiceProposals(claimNumber)); 

      const claimReparationMissions = await dispatch(Actions.getClaimReparationMissions(claimNumber));
      const claimfinancialDocument = await dispatch(Actions.getFinancialDocuments(claimNumber));
      setServiceProposals(claimServiceProposals);
      setReparationMissions(claimReparationMissions);
      setFinancialDocuments(claimfinancialDocument);
    } catch (error) {
      setError(error.message || 'An error occurred while fetching data');
    }
    setLoading(false);
  };

  useEffect(() => {
    if (claimNumber) {
      fetchClaimAssociatedData();
    }
  }, [claimNumber]);
  const [dataClientPart, setDataClientPart] = useState({
    franchise: 0,
    rp: 0,
    ceilingExceedance: 0,
    customerPayment: 0
});
  useEffect(() => {
    if (serviceProposals.length > 0) {
     
        setDataClientPart({
            franchise: serviceProposals[serviceProposals.length - 1].franchise|| "-",
            rp: serviceProposals[serviceProposals.length - 1].rp  || "-",
            ceilingExceedance: serviceProposals[serviceProposals.length - 1].ceilingExceedance  || "-",
            customerPayment: serviceProposals[serviceProposals.length - 1].customerPayment || "-"
        })
      }
  }, [serviceProposals]);



  
  const renderReparationMissions = () => {
    return reparationMissions.map((mission, index) => (
        <AccordionItem key={mission._id} className={`${classes.customAccordionItem} ${renderAsSpans ? classes.expanded : ''}`}>
          <AccordionButton onClick={() => toggleExpansion(`reparation-${index}`, expandedItems, setExpandedItems)}
                           style={{ height: "47px", border: "none", background: "rgba(249, 249, 249, 1)", padding: "10px", borderRadius: "11px" }}>
            <AccordionIcon size="30px" style={{ backgroundColor: "rgba(240, 243, 199, 1)", width: "25px", height: "25px", borderRadius: "5px", color: "rgba(187, 200, 8, 1)" }} />
            <Box as="span" textAlign='left' marginLeft='20px' style={{ color: "rgba(0, 34, 38, 1)", fontSize: '15px', fontWeight: 500, lineHeight: '21px', fontFamily: 'Poppins', }}>
              Mission de réparation
            </Box>
          </AccordionButton>
          <AccordionPanel style={{ width: "100%", background: 'rgba(255, 255, 255, 1)', padding: '30px', borderRadius: "11px" }}>
            <Grid container spacing={2}>
              <Grid item>
                <div className={getLabelClass(renderAsSpans, classes)}>N° Mission</div>
                {/*<input disabled className={classes.styleInput} type='text' value={mission.missionNumber || "N/A"} />*/}
                {renderInputOrSpan(renderAsSpans, mission.missionNumber || "N/A", classes)}
              </Grid>
              <Grid item>
                <div className={getLabelClass(renderAsSpans, classes)}>Date mission</div>
                {/*<input disabled className={classes.styleInput} type='text' value={getDateFromString(mission.createdAt).toString() || "N/A"} />*/}
                {renderInputOrSpan(renderAsSpans, getDateFromString(mission.createdAt).toString() || "N/A", classes)}
              </Grid>
              <Grid item>
                <div className={getLabelClass(renderAsSpans, classes)}>Réparateur désigné</div>
                {/*<input disabled className={classes.styleInput} type='text' value={mission.associatedRepairer.organizationName || "N/A"} />*/}
                {renderInputOrSpan(renderAsSpans, mission.associatedRepairer.organizationName || "N/A", classes)}
              </Grid>
              <Grid item>
                <div className={getLabelClass(renderAsSpans, classes)}>Décision réparateur</div>
                {/*<input disabled className={classes.styleInput} type='text' value={mission.repairerDecision || "N/A"} />*/}
                {renderInputOrSpan(renderAsSpans, translateRepairDecision(mission.repairerDecision) || "N/A", classes)}
              </Grid>
              <Grid item>
                <div className={getLabelClass(renderAsSpans, classes)}>Total des réparations</div>
{/*                <input */}
{/*  disabled */}
{/*  className={classes.styleInput} */}
{/*  type='text' */}
{/*  value={*/}
{/*    mission && */}
{/*    mission.financialDocuments && */}
{/*    mission.financialDocuments.length > 0 */}
{/*      ? mission.financialDocuments[mission.financialDocuments.length - 1].totalAmountWTax*/}
{/*      : "N/A"*/}
{/*  }*/}
{/*/>*/}
                {renderInputOrSpan(
                    renderAsSpans,
                    (() => {
                        const invoices = financialDocuments?.filter(doc => doc.type === "INVOICE") || [];
                        return invoices.length > 0 ? invoices[invoices.length - 1].totalAmountWTax : "N/A";
                    })(),
                    classes
                )}
              </Grid>
              <Grid item>
                <div className={getLabelClass(renderAsSpans, classes)}>Date d'entrée prévisionelle</div>
                {/*<input disabled className={classes.styleInput} type='text' value={mission.repairDecision || "N/A"} />*/}
                {renderInputOrSpan(renderAsSpans,getDateFromString(mission.serviceProposal.estimatedCarDeposalDate).toString()  || "N/A", classes)}
              </Grid>

              <Grid item>
                <div className={getLabelClass(renderAsSpans, classes)}>Date début de reparations</div>
                {/*<input disabled className={classes.styleInput} type='text' value={mission.repairDecision || "N/A"} />*/}
                {renderInputOrSpan(renderAsSpans, getDateFromString(mission.estimatedReparationEntryDate).toString() || "N/A", classes)}
              </Grid>
              <Grid item>
                <div className={getLabelClass(renderAsSpans, classes)}>Date fin de réparation</div>
                {/*<input disabled className={classes.styleInput} type='text' value={mission.repairDecision || "N/A"} />*/}
                {renderInputOrSpan(renderAsSpans, getDateFromString(mission.estimatedReparationEndDate).toString() || "N/A", classes)}
              </Grid>
            </Grid>
          </AccordionPanel>
        </AccordionItem>
    ));
  };

  const renderServiceProposals = () => {
    return serviceProposals.map((proposal, index) => (
        <AccordionItem key={proposal._id} className={`${classes.customAccordionItem} ${renderAsSpans ? classes.expanded : ''}`}>
          <AccordionButton onClick={() => toggleExpansion(index, expandedItems, setExpandedItems)}
                           style={{ height: "47px", border: "none", background: "rgba(249, 249, 249, 1)", padding: "10px", borderRadius: "11px" }}>
            <AccordionIcon size="30px" style={{ backgroundColor: "rgba(240, 243, 199, 1)", width: "25px", height: "25px", borderRadius: "5px", color: "rgba(187, 200, 8, 1)" }} />
            <Box as="span" textAlign='left' marginLeft='20px' style={{ color: "rgba(0, 34, 38, 1)", fontSize: '15px', fontWeight: 500, lineHeight: '21px', fontFamily: 'Poppins', }}>
              Proposition de service
            </Box>
            <div style={{
              marginLeft: '10px', height: '26px', borderRadius: '51px', background: 'rgba(240, 243, 199, 1)', textAlign: 'center', padding: '5px 20px',
              fontFamily: 'Poppins', fontSize: '10.69px', fontWeight: 400, lineHeight: '16.03px', color: 'rgba(187, 200, 8, 1)',
            }}>
              {proposal?.proposedService?.label || "N/A"}
            </div>
          </AccordionButton>
          <AccordionPanel style={{ width: "100%", background: 'rgba(255, 255, 255, 1)', padding: '30px', borderRadius: "11px" }}>
            <Grid container spacing={2}>
              <Grid item>
                <div className={getLabelClass(renderAsSpans, classes)}>Date proposition de service</div>
                {/*<input disabled className={classes.styleInput} type='text' value={getDateFromString(proposal?.date?.toString()) || "N/A"} />*/}
                {renderInputOrSpan(renderAsSpans, getDateFromString(proposal?.date?.toString()) || "N/A", classes)}
              </Grid>
              <Grid item>
                <div className={getLabelClass(renderAsSpans, classes)}>Décision du client</div>
                {/*<input disabled className={classes.styleInput} type='text' value={proposal.clientDecision || "N/A"} />*/}
                {renderInputOrSpan(renderAsSpans, translateClientDecision(proposal.clientDecision) || "N/A", classes)}
              </Grid>
              {proposal.clientDecision ==="REFUSAL" ?
                <Grid item>
                  <div className={getLabelClass(renderAsSpans, classes)}>Motif de la décision</div>
                  {/*<input disabled className={classes.styleInput} type='text' value={proposal.decisionReason || "N/A"} />*/}
                  {renderInputOrSpan(renderAsSpans, proposal.decisionReason  || "N/A", classes)}
                </Grid>
               : <></>}
              
              <Grid item>
                <div className={getLabelClass(renderAsSpans, classes)}>Date prévue déplacement client</div>
                {/*<input disabled className={classes.styleInput} type='text' value={getDateFromString(proposal?.estimatedCarDeposalDate).toString() || "N/A"} />*/}
                {renderInputOrSpan(renderAsSpans, getDateFromString(proposal?.estimatedCarDeposalDate).toString() || "N/A", classes)}
              </Grid>
              <Grid item>
                <div className={getLabelClass(renderAsSpans, classes)}>Paiement du client</div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {renderInputOrSpanForButton(renderAsSpans, proposal.customerPayment|| "N/A", classes)}
                  <button
                    style={{
                      padding: '10px',
                      marginLeft: '-5px',
                      border: 'none',
                      background: '#3C6556',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      borderRadius: '0 5px 5px 0'
                    }}
                    onClick={handlePaymentClick}
                  >
                 <svg   width="16px" height="16px"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="none" stroke="white" stroke-width="20">
                  <path d="M360 80v-64H72L8 80v416h352V304" stroke-linejoin="round"/>
                  <path d="M72 80V16" stroke-linecap="round"/>
                  <path d="M64 128h56M64 176h112M64 224h32M112 224h72M64 280h120M64 328h40M120 328h184M64 376h168M64 424h96M184 424h120" stroke-linecap="round"/>
                  <circle cx="312" cy="184" r="112"/>
                  <path d="M408 280l88 88c8 8 8 20 0 28s-20 8-28 0l-88-88" stroke-linecap="round"/>
                  <path d="M280 168h32M328 168h16M256 224h80" stroke-linecap="round"/>
                </svg>

                
                  </button>
                </div>
                
              </Grid>
            </Grid>
          </AccordionPanel>
        </AccordionItem>
    ));
  };

  return (
      <div style={{ padding: "40px" }}>
        <Accordion defaultIndex={[0]} allowMultiple>
          {loading ? (
              <>
                {[...Array(3)].map((_, index) => (
                    <AccordionItem key={index} className={`${classes.customAccordionItem} ${renderAsSpans ? classes.expanded : ''}`}>
                      <AccordionButton onClick={() => toggleExpansion(index, expandedItems, setExpandedItems)}
                                       style={{ height: "47px", border: "none", background: "rgba(249, 249, 249, 1)", padding: "10px", borderRadius: "11px" }}>
                        <AccordionIcon style={{ backgroundColor: "rgba(240, 243, 199, 1)", width: "25px", height: "25px", borderRadius: "5px", color: "rgba(187, 200, 8, 1)", marginRight: '2%' }} />
                        <Skeleton animation="wave" width={160} height={30} />
                      </AccordionButton>
                      <AccordionPanel style={{ width: "100%", background: 'rgba(255, 255, 255, 1)', padding: '40px', borderRadius: "11px" }}>
                        <Grid container style={{ justifyContent: 'start', marginBottom: '10px' }} spacing={6}>
                          {[...Array(5)].map((_, i) => (
                              <Grid item key={i}>
                                <Skeleton animation="wave" width={241} height={50} />
                              </Grid>
                          ))}
                        </Grid>
                      </AccordionPanel>
                    </AccordionItem>
                ))}
              </>
          ) : (serviceProposals.length === 0 && reparationMissions.length === 0) ? (
            <Box style={{fontFamily : 'Poppins', fontWeight : 400 ,fontSize :15, lineHeight:'22.5px' ,color :'rgba(70, 78, 95, 1)'  }}>
              Aucune prise en charge n'est trouvée pour ce sinistre
              </Box>
          ) : (
              <>
                {renderServiceProposals()}
                {renderReparationMissions()}
              </>
          )}
        </Accordion>
        {showPaymentModal && (
        <Dialog onClose={handleClosePaymentModal} open={showPaymentModal}>
          <DialogTitle style={{
            fontFamily: 'Poppins',
            fontSize: '16px',
            width: '30rem',
            backgroundColor: "rgba(243, 246, 249, 1)"
          }}>
            Détail part du client
          </DialogTitle>
          <DialogContent>
           
          <div className={classes.card}>
          
            <div className={classes.cardItem}>
                <span>Franchise</span>
                <span>{dataClientPart.franchise || "-"}</span>            
            </div>
            <div className={classes.cardItem}>
                <span>RP</span>
                <span>{dataClientPart.rp || "-"}</span>
            </div>
            <div className={classes.cardItem}>
                <span>TVA</span>
                <span>{dataClientPart.tva || "-"}</span>
            </div>
            <div className={classes.cardItem}>
                <span>Dépassement plafond</span>
                <span>{dataClientPart.ceilingExceedance || "-"}</span>
            </div>
            <div className={classes.cardItem}>
                <span style={{ color: "rgba(60, 101, 86, 1)", fontFamily: 'Poppins', fontSize: '13px', fontWeight: 700 }}>Total</span>
                <span>{dataClientPart.customerPayment || "-"}</span>
            </div>
        </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleClosePaymentModal}
              style={{
                fontFamily: "Poppins",
                fontSize: "10.76px",
                fontWeight: 600,
                lineHeight: "16.14px",
                color: "rgba(255, 255, 255, 1)",
                background: "rgba(60, 101, 86, 1)",
                borderRadius: "5.38px",
                marginRight: "10px",
              }}
            >
              Fermer
            </Button>
          </DialogActions>
        </Dialog>

      )}
      </div>
     
  );
}

export default PriseEnChargeSection;
